<template>
    <div class="actions-container">
        <div class="actions__header">
            <div class="date">{{eventDate}}</div>
            <button class="btn-close" @click="close"></button>
        </div>
        <div class="actions__content">
            <div class="div container">
                <div class="actions-icon">
                    <div class="action-icon" v-for="eventAction in eventActions">
                        <div class="icon">
                            <img :src="eventAction.imgSrc" alt="">
                        </div>
                    </div>
                </div>
                <div class="actions">
                    <div class="action" v-for="eventAction in eventActions">
                        <div class="title" v-text="eventAction.title"></div>
                        <p v-text="eventAction.text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Slick from 'slick-carousel';
    import { eventBus } from '../../main';

    export default {
        props: [
                'eventDate',
                'eventActions'
        ],
        data() {
            return {}
        },
        mounted() {
            //initialisation de slick js
            //carousel sur les actions
            $('.actions').slick({
                arrows: false,
                dots: true,
                asNavFor: '.actions-icon',
                infinite: false
            });
            //carousel sur les icones liés aux actions
            $('.actions-icon').slick({
                arrows: false,
                dots: false,
                asNavFor: '.actions',
                infinite: false
            });
        },
        methods: {
            close() {
                eventBus.$emit('actions:close');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Actions.vue?19da0424